import { AxiosResponse } from 'axios'
import api from '~/services/api'
import {
  transformOrder,
  transformPayResponse,
  transformCheckTransaction
} from './../utils/transformOrderFetchData'
import { getDumpFromQuery } from './../utils/getDumpFromQuery'
import { API_ENDPOINTS } from './../constants'
import {
  IOrder,
  IPayData,
  IPayResponse,
  IFetchDivideCheck,
  IChekTransactionResponse
} from './../model/types'

export const fetch = async (
  tableId: string | number,
  domen: string,
  session: string | null,
  guest: number | null,
  browserId: string | null,
  orderGuid?: string,
  timeout?: number
): Promise<IOrder> => {
  const { data }: AxiosResponse = await api.post(API_ENDPOINTS.GET_ORDER, {
    table_id: tableId,
    domen,
    guest,
    browser_id: browserId,
    session,
    order_guid: orderGuid,
    ...(getDumpFromQuery() ? { dump: true } : {})
  }, { timeout })
  return transformOrder(data)
}

export const checkOrderPosition = async (id: string | number[], status: boolean, guest: number | null, transactionReset?: boolean, timeout?: number): Promise<boolean> => {
  const { data }: AxiosResponse = await api.post(API_ENDPOINTS.CHANGE_ORDER_POSITION, {
    check_status: !status,
    guest: guest ? Number(guest) : null,
    positions_id: id,
    transaction_reset: transactionReset
  }, { timeout })
  return data.success
}

export const pay = async (payload: IPayData): Promise<IPayResponse> => {
  const { data }: AxiosResponse = await api.post(API_ENDPOINTS.PAY_ORDER, payload)
  return transformPayResponse(data)
}

export const checkDivideBill = async (id: number) => {
  const { data }: AxiosResponse<IFetchDivideCheck> = await api.get(API_ENDPOINTS.CHECK_DIVIDE_BILL(id))
  return data
}

export const checkTransaction = async <T>(id: T): Promise<IChekTransactionResponse> => {
  const { data }: AxiosResponse = await api.get(API_ENDPOINTS.CHECK_TRANSACTION(id))
  return transformCheckTransaction(data)
}
